<template>
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="100%"
    height="100%"
    viewBox="0 0 188.82 188.82"
    style="overflow: visible; enable-background: new 0 0 188.82 188.82"
    xml:space="preserve"
    class="fill-current"
  >
    <path
      d="M102.66,93.53h23.84l-12.07-33.17L102.66,93.53z M62.46,93.53H86.3L74.23,60.36L62.46,93.53z M94.41,0
	C42.27,0,0,42.27,0,94.41s42.27,94.41,94.41,94.41s94.41-42.27,94.41-94.41C188.81,42.27,146.55,0,94.41,0z M142.87,137.76
	l-11.49-30.33h-25.43l11.23,30.33h-14.5L94.44,116l-8.14,21.76H71.65l11.23-30.33H57.45L46.1,137.76H31.45l38.06-102.8h9.62
	l15.29,41.3l15.29-41.3h9.62l38.06,102.8L142.87,137.76L142.87,137.76z"
    />
  </svg>
</template>
